
Greenmile.Checks = Greenmile.Checks || {};
Greenmile.Checks.EventCheck = Greenmile.Checks.EventCheck || {};

Greenmile.Checks.EventCheck.PlannedProjectedArrivalDeviation = {

  template() {
    return {
      tag: 'div',
      items: [
        {
          items: [
            {
              tag: 'label',
              items: [
                {
                  tag: 'span',
                  html: Monet.I18n.getResourcesByKey('event.projectedArrivalDeviation.timeBefore'),
                  attributes: {
                    'class': 'i18nResource',
                  },
                },
              ],
              attributes: {
                class: 'control-label',
                for: 'arrive_at_stop_before',
              },
            },
            {
              items: [
                {
                  tag: 'input',
                  attributes: {
                    'type': 'text',
                    name: 'arrive_at_stop_before',
                    maxlength: '10',
                    alt: '',
                    'value': '',
                    'size': '11',
                    id: 'arrive_at_stop_before',
                    'class': 'modelAttribute textField numberPicker',
                    'autocomplete': 'off',
                  },
                },
              ],
              attributes: {
                class: 'controls',
              },
            },
          ],
          attributes: {
            class: 'control-group',
          },
        },
        {
          items: [
            {
              tag: 'label',
              items: [
                {
                  tag: 'span',
                  html: Monet.I18n.getResourcesByKey('event.projectedArrivalDeviation.timeAfter'),
                  attributes: {
                    'class': 'i18nResource',
                  },
                },
              ],
              attributes: {
                class: 'control-label',
                for: 'arrive_at_stop_after',
              },
            },
            {
              items: [
                {
                  tag: 'input',
                  attributes: {
                    type: 'text',
                    name: 'arrive_at_stop_after',
                    maxlength: '10',
                    alt: '',
                    value: '',
                    'size': '11',
                    'id': 'arrive_at_stop_after',
                    'class': 'modelAttribute textField numberPicker mandatory',
                    'autocomplete': 'off',
                  },
                },
              ],
              attributes: {
                class: 'controls',
              },
            },
          ],
          attributes: {
            class: 'control-group',
          },
        },
      ],
    };
  },

  assignParameter(jsonParam) {
    if (jsonParam) {
      jsonParam = JSON.parse(jsonParam);

      $('#arrive_at_stop_before').val(jsonParam.toleranceBeforePlanned);
      $('#arrive_at_stop_after').val(jsonParam.toleranceAfterPlanned);
    }
  },
  retrieveParameter() {
    const timeMinutesBefore = parseInt($('#arrive_at_stop_before').val(), 10);
    const timeMinutesAfter = parseInt($('#arrive_at_stop_after').val(), 10);

    return JSON.stringify({
      toleranceBeforePlanned: timeMinutesBefore,
      toleranceAfterPlanned: timeMinutesAfter,
    });
  },

};
